import { createFileRoute } from '@tanstack/react-router';

import { EmployeeDepartmentOrgChartPage } from '../modules/ComponentsLibrary/Reports/pages/EmployeeDepartmentOrgChart';

export const Route = createFileRoute('/reports/employee-org-chart')({
  component: EmployeeDepartmentOrgChartPage,
  head() {
    return {
      meta: [{ title: 'Employee org chart | Reports' }],
    };
  },
});
